// removed by extract-text-webpack-plugin
module.exports = {"module-title":"_2_dSDfjzFsqoCGNTfI73dD","chevron":"_3GoIdwrZqi6FfA44mZ3Unf","rotated":"_1_meePzQT-rY3SVbaj6dsb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/JournalPrompts.mod.css
// module id = 1795
// module chunks = 0